export const DRIFT_INTEL_PROPERTIES = Object.freeze([
  {
    label: 'Company Name',
    value: 'name',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Location',
    value: 'location',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Type',
    value: 'type',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Domain',
    value: 'domain',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Tags',
    value: 'tags',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Tech',
    value: 'tech',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Facebook',
    value: 'facebook',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company City',
    value: 'geo.city',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company State',
    value: 'geo.state',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company State Code',
    value: 'geo.stateCode',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Country',
    value: 'geo.country',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Country Code',
    value: 'geo.countryCode',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Postal Code',
    value: 'geo.postalCode',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Latitude',
    value: 'geo.lat',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Longitude',
    value: 'geo.lng',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Github',
    value: 'github',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Twitter',
    value: 'twitter',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company LinkedIn',
    value: 'linkedin',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Google Plus',
    value: 'googleplus',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Angel List',
    value: 'angellist',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Customer',
    value: 'customer',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Crunchbase',
    value: 'crunchbase',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Capital Raised',
    value: 'metrics.raised',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Headcount',
    value: 'metrics.employees',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Google Rank',
    value: 'metrics.googleRank',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Alexa US Rank',
    value: 'metrics.alexaUsRank',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Alexa Global Rank',
    value: 'metrics.alexaGlobalRank',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Market Cap',
    value: 'metrics.marketCap',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Estimated Annual Revenue',
    value: 'metrics.estimatedAnnualRevenue',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Sector',
    value: 'category.sector',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Industry',
    value: 'category.industry',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Industry Group',
    value: 'category.industryGroup',
    source: 'driftintel',
    hasNoFallback: false,
  },
  {
    label: 'Company Sub Industry',
    value: 'category.subIndustry',
    source: 'driftintel',
    hasNoFallback: false,
  },
])
